import InfoCardErrorView from "components/InfoCardErrorView";
import MonthlyProductionChart from "components/MonthlyProductionChart";
import config from "config";
import { useScadaPlusQuery } from "hooks/useScadaPlusQuery";
import { useScadaPlusTheme } from "hooks/useScadaPlusTheme";
import React, { useState } from "react";
import { Production, ProductionProps } from "types";
import { constructProductionUrl } from "utils/production-utils";

// used for demo dummy data
import {
  isDemoUrl,
  monthlyGraphDemoDummyData,
} from "utils/demo-dummy-data-utils";
import { getEnvConfig } from "env";

export const MonthlyProductionCard: React.FC<ProductionProps> = (props) => {
  const { theme } = useScadaPlusTheme();
  const [lastQueriedTimestamp, setLastQueriedTimeStamp] = useState<
    Date | undefined
  >(undefined);
  const [clientError, setClientError] = useState<string | undefined>(undefined);
  const { data, isFetching, error } = useScadaPlusQuery<Production>(
    `productionMonth-${props.idCollection.plantId}-${props.idCollection.sectionId}`,
    () => {
      const aggregateUrlParam = "aggregateBy=DayInMonth";
      const baseUrl = `${getEnvConfig("API_URL")}/api/${config.api.production}`;
      return constructProductionUrl(
        baseUrl,
        props.idCollection,
        aggregateUrlParam,
      );
    },
    60 * 1000,
    (errorMessage) => {
      if (errorMessage.status) {
        setClientError(
          `Server response status: ${errorMessage.status} - ${errorMessage.text}`,
        );
      } else {
        setClientError(errorMessage.text);
      }
    },
    () => {
      setClientError(undefined);
      setLastQueriedTimeStamp(new Date());
    },
  );

  return error || clientError ? (
    <InfoCardErrorView
      lastQueriedTimestamp={lastQueriedTimestamp}
      theme={theme}
      // TODO, hvordan typedefinere error i UseQueryResult slik at komponent vet returnert feil-type
      error={typeof error === "string" ? error : ""}
    />
  ) : (
    // toDo: remove demodummydata part when we can provide simulated data
    // this is only a temporary fix to provide dummy data to demo graphs

    <MonthlyProductionChart
      data={isDemoUrl() ? monthlyGraphDemoDummyData(props.idCollection) : data}
      isFetching={isFetching}
    />
  );
};
